import LogRocket from 'logrocket';

const initLogRocket = () => {
  const logRocketId = import.meta.env.VITE_APP_LOGROCKET_ID;
  console.log('Initialize log rocket for app');
  if (logRocketId && logRocketId !== '') {
    LogRocket.init('software-defined-automation/phoenix');
  }
};

// Before createRoot the 125 kB recorder ran inside the boot and the Cognito chain
// (home shell -0.4..-0.5 s under 4x CPU with it blocked); the shim buffers calls until it loads.
export const initLogRocketWhenIdle = () => {
  if (typeof window.requestIdleCallback === 'function') {
    // Capped: the login DOM is not buffered, so a busy page must not push the start back.
    window.requestIdleCallback(() => initLogRocket(), { timeout: 2000 });
    return;
  }
  // Safari has no requestIdleCallback; a macrotask still lands after the synchronous boot.
  setTimeout(initLogRocket, 0);
};
